import { gql } from '@apollo/client'
import { client } from '../client';


const CHECK_AUTH_CODE_MUTATION = gql`
  mutation Mutation($registrationNumber: String!) {
      checkRegisteredTransportation(registrationNumber: $registrationNumber)
  }
`

interface CheckRegisteredTransportationData {
  checkRegisteredTransportation: boolean
}

interface CheckRegisteredTransportationVars {
  registrationNumber: string,
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const checkRegisteredTransportation = (args: CheckRegisteredTransportationVars) => {
  return client.mutate<CheckRegisteredTransportationData, CheckRegisteredTransportationVars>({
    mutation: CHECK_AUTH_CODE_MUTATION,
    variables: args,
  })
}
